import { render, staticRenderFns } from "./ContractModal.vue?vue&type=template&id=23895c48&scoped=true&"
import script from "./ContractModal.vue?vue&type=script&lang=js&"
export * from "./ContractModal.vue?vue&type=script&lang=js&"
import style0 from "./ContractModal.vue?vue&type=style&index=0&id=23895c48&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23895c48",
  null
  
)

export default component.exports